export const generateKeyframes = (listCount, wth, flag, slide) => {
  // listCount: 列表数组
  // wth: 每帧移动距离(rem)
  // flag: 移动方向(true为向右，false为向左)
  // slide: 动画名称
  if (!listCount || !listCount.length || !wth || !slide) return '';
  const step = 100 / listCount.length;
  let lastTranslateX = null;
  let endStep = null;
  let keyframes = `
        0%,
        100% {
          z-index: 1;
          transform: translateX(0);
          opacity: 100%;
        }
      `;
  for (let i = 0; i < listCount.length - 1; i += 1) {
    const start = (step * i + step / 3).toFixed(2);
    const end = (step * (i + 1)).toFixed(2);
    endStep = end;
    const zIndex = i + 2;
    const translateX = `${((i + 1) * wth)}`;
    lastTranslateX = translateX;
    const opacity = 100;
    keyframes += `
        ${start}%,
        ${end}% {
          z-index: ${zIndex};
          transform: translateX(${flag ? '+' : '-'}${translateX}rem);
          opacity: ${opacity}%;
        }
      `;
  }
  keyframes += `
      ${+endStep + 3}% {
        z-index: 0;
        transform: translateX(${flag ? '+' : '-'}${+lastTranslateX + 0.02}rem);
        opacity: 20%;
      }

      ${+endStep + 3.1}% {
        transform: translateX(0);
        opacity: 50%;
      }`;
  return `
        @keyframes ${slide} {
          ${keyframes}
        }
      `;
};

export const applyDynamicKeyframes = (listCount, wth, flag, slide) => {
  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerHTML = generateKeyframes(listCount, wth, flag, slide);
  document.head.appendChild(styleSheet);
};

export default applyDynamicKeyframes;
